import { SearchFilter, SearchFilterStar, SearchTravelResult, SearchTravelSortItem } from '@/types/models';
import { SearchTravelResponse } from '@/types/models';
import { MultiRangeValues, SearchTravelFilterRequest, ValueIndexParams } from '@/types/paramModels';
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';

@Module({ namespaced: true, })
class TravelSearchResponseModule extends VuexModule {
    public searchTravelResponse!: SearchTravelResponse;

    @Mutation
    public setSearchTravelResponse(searchTravelResponse: SearchTravelResponse): void {
        this.searchTravelResponse = searchTravelResponse;
    }

    @Action
    public updateSearchTravelResponse(searchTravelResponse: SearchTravelResponse): void {
        this.context.commit('setSearchTravelResponse', searchTravelResponse);
    }

    get getSearchTravelResponse(): SearchTravelResponse {
        return this.searchTravelResponse;
    }

    @Mutation
    private setDeleteSearchTravelResponse(): void {
        this.searchTravelResponse = {} as SearchTravelResponse;
    }

    @Action
    public deleteSearchTravelResponse(): void {
        this.context.commit('setDeleteSearchTravelResponse');
    }

    @Mutation
    private setIncrementPaging(): void {
        if (this.searchTravelResponse)
            this.searchTravelResponse.paging.pageNumber++;
    }

    @Action
    public incrementPaging(): void {
        this.context.commit('setIncrementPaging');
    }

    @Mutation
    private setAddPageTravels(travels: Array<SearchTravelResult>) {
        if(this.searchTravelResponse) {
            for(const travel of travels) {
                this.searchTravelResponse.travels.push(travel);
            }
        }
    }

    @Action
    public addPageTravels(travels: Array<SearchTravelResult>) {
        this.context.commit('setAddPageTravels', travels);
    }

    @Mutation
    private setUpdatedFilters(searchFilter: SearchFilter) {
        if(this.searchTravelResponse) {
            this.searchTravelResponse.paging.pageNumber = 1;
            this.searchTravelResponse.searchFilter = searchFilter;
        }
    }

    @Action
    public updateFilters(searchFilter: SearchFilter) {
        this.context.commit('setUpdatedFilters', searchFilter);
    }

    @Mutation
    private setUpdatedFilterStars(params: ValueIndexParams) {
        if(this.searchTravelResponse) {
            this.searchTravelResponse.paging.pageNumber = 1;
            this.searchTravelResponse.searchFilter.stars[params.index].selected = params.value;
        }
    }

    @Action
    public updateFilterStars(params: ValueIndexParams) {
        this.context.commit('setUpdatedFilterStars', params);
    }

    @Mutation
    private setUpdatedFilterCategories(params: ValueIndexParams) {
        if(this.searchTravelResponse) {
            this.searchTravelResponse.paging.pageNumber = 1;
            this.searchTravelResponse.searchFilter.categories[params.index].selected = params.value;
        }
    }

    @Action
    public updateFilterCategories(params: ValueIndexParams) {
        this.context.commit('setUpdatedFilterCategories', params);
    }

    @Mutation
    private setUpdatedSortItem(sortItem: SearchTravelSortItem) {
        if(this.searchTravelResponse) {
            this.searchTravelResponse.paging.pageNumber = 1;
            for(const item of this.searchTravelResponse.sorting.items) {
                if(item.id === sortItem.id) {
                    item.selected = true;
                } else {
                    item.selected = false;
                }
            }
        }
    }

    @Action
    public updateSorting(sortItem: SearchTravelSortItem) {
        this.context.commit('setUpdatedSortItem', sortItem);
    }

    @Mutation
    private setFilterMinimumPrice(minPrice: number) {
        if(this.searchTravelResponse) {
            this.searchTravelResponse.paging.pageNumber = 1;
            this.searchTravelResponse.searchFilter.minPrice = minPrice;
        }
    }

    @Action
    public updateFilterMinimumPrice(minPrice: number) {
        this.context.commit('setFilterMinimumPrice', minPrice);
    }

    @Mutation
    private setFilterMaxiumPrice(maxPrice: number) {
        if(this.searchTravelResponse) {
            this.searchTravelResponse.paging.pageNumber = 1;
            this.searchTravelResponse.searchFilter.maxPrice = maxPrice;
        }
    }

    @Action
    public updateFilterMaximumPrice(maxPrice: number) {
        this.context.commit('setFilterMaxiumPrice', maxPrice);
    }

    @Mutation
    private setUpdatedFilterPriceRange(range: MultiRangeValues) {
        if(this.searchTravelResponse) {
            this.searchTravelResponse.searchFilter.minPrice = range.minValue;
            this.searchTravelResponse.searchFilter.maxPrice = range.maxValue;
        }
    }

    @Action
    public updateFilterPriceRange(range: MultiRangeValues) {
        this.context.commit('setUpdatedFilterPriceRange', range);
    }

    @Mutation
    private setFilterQuery(query: string) {
        if(this.searchTravelResponse) {
            this.searchTravelResponse.paging.pageNumber = 1;
            this.searchTravelResponse.searchFilter.query = query;
        }
    }

    @Action
    public updateFilterQuery(query: string) {
        this.context.commit('setFilterQuery', query);
    }

}

export default TravelSearchResponseModule;